import React, { useEffect, useState, useRef } from 'react';
import "../../doctor/components/allpages.css";
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import Menu from '@mui/material/Menu';
import { Button, Dialog, DialogTitle, IconButton, DialogContent } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { updateLeadStatusApi } from '../../../api/userApi/userApi';
import useEncryption from '../../../services/useEncryption';
import useHeaders from '../../../helpers/useHeaders';
import useToast from '../../../helpers/useToast';
import { useParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { toast } from 'react-toastify';
import { getAllPipeLineLeadsApi } from '../../../api/pipeLineApi/pipeLineApi';
import { createAuditLogs } from '../../../api/providerApi/providerApi';
import CloseIcon from '@mui/icons-material/Close';
import ContactInfoForm from '../../doctor/components/ContactInfoForm';
import { getAgeCategory } from '../../../helpers/utils';
import { getTopSymptoms } from "../../../helpers/utils";
import AddNotesModal from '../../doctor/components/AddNotesModal';
import Notes from '../../doctor/components/Notes';
import { above13AgeQuestionsBVDQ, age4to8QuestionsBVDQ, age9to13QuestionsBVDQ , age4to8QuestionsHistory, above13AgeQuestionsHistory, age9to13QuestionsHistory} from '../../../helpers/questions';


// Define item type for drag-and-drop
const ItemType = 'ITEM';

// Draggable item component
const DraggableItem = ({ id, item, columnId, moveItem }) => {

  const [, drag] = useDrag({
    type: ItemType,
    item: { id, columnId },
  });

  // Apply specific styling if the item is in the "In Process" column
  const isInProcess = columnId === 'in-process';
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEn, setAnchorEn] = React.useState(null);
  const open = Boolean(anchorEl);
  const opens = Boolean(anchorEn);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClicknoti = (event) => {
    setAnchorEn(event.currentTarget);
  }
  const handleClosed = () => {
    setAnchorEn(null);
  };


  const [openDialouge, setopenDialouge] = useState(false);
  const [openM, setOpenM] = useState(false);
  const dialogRef = useRef(null);
  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [updatedNotes, setUpdatedNotes] = useState(false);
  const pointerRef = useRef(null);
  const sliderBarRef = useRef(null);
  const { encryptData, decryptData } = useEncryption();
  const toastOptions = useToast();
  const headers = useHeaders();

  const handleCloseMdle = () => {
    if(!selectedLead) {
        setSelectedLeadId(null);
    }
    setUpdatedNotes(prev => !prev); 
    setOpenM(false);
  };

  const topSymptoms = getTopSymptoms(selectedLead?.formsortResponse?.answers);

  const answers = selectedLead?.formsortResponse?.answers;

  const topSymptomNames = topSymptoms.map(symptom => symptom.name);

  const symptomKeyMap = {
      'Dizziness': 'dizziness',
      'Nausea': 'nausea',
      'Anxiety': 'anxiety',
      'Headaches': 'headache',
      'Neck Pain': 'neck_pain',
      'Unsteady with Walking': 'balance_issues',
      'Sensitivity to Light': 'light_sensitivity',
      'Reading Difficulty': 'reading_challenges',
      'Sound Sensitivity': 'sound_sensitivity'
  };

  const score = answers?.above13age_bvdq_scores ?? answers?.['4to8age_bvdq_scores'] ?? answers?.['9to13age_bvdq_scores'] ?? "--";


  const handleClosedLeadModal = () => {
    setopenDialouge(false);
    setSelectedLead(null);
    setSelectedLeadId(null);
  };

  const getclassName = (status) => {
    switch (status) {
        case "New Lead":
            return 'newlead';
        case "Scheduled For Contact":
            return 'scheduledcontact';
        case "Contact Attempted":
            return 'contacted';
        case "Ready To Schedule":
            return 'readytoSchedule';   
        case "In Process":
            return 'inprogress';
        case "Scheduled":
            return 'scheduled';
        case "UnScheduled":
            return 'unscheduled';
        case "Archived":
            return 'archived';
        default:
            return '';
    }
  };

  const handleStatusUpdate = async (event) => {
    const newStatus = event.target.value;
    const leadId = selectedLead._id;
    const previousLead = { ...selectedLead };
  
    setSelectedLead((prevLead) => ({
        ...prevLead,
        status: newStatus
    }));
  
    try {
        const payload = {
            status: newStatus
        };
        const data = encryptData(payload);
        const response = await updateLeadStatusApi(leadId, data, headers);
        let obj = {
            event : 'Doctor has updated the lead status.'
        }
        await createAuditLogs({ data: encryptData(obj)}, headers);
        toast.success(response.data.message, toastOptions);
    } catch (error) {
        setSelectedLead(previousLead);
        toast.error(error?.response?.data?.message, toastOptions);
    }
  };

  const handleCopy = () => {
    if (selectedLead?.patientId) {
      navigator.clipboard.writeText(selectedLead?.patientId);
      toast.success("Patient ID copied to clipboard!");
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  const adultMaxScore = 75;
  const preTeenMaxScore = 48;
  const childMaxScore = 13;

  const adultPointerPosition =
      score !== "--" && score >= 0 && score <= adultMaxScore
        ? (score / adultMaxScore) * 100
        : 0;

  const preteenPointerPosition =
        score !== "--" && score >= 0 && score <= preTeenMaxScore
          ? (score / preTeenMaxScore) * 100
          : 0;

  const childPointerPosition = 
        score !== "--" && score >= 0 && score <= childMaxScore 
       ? (score / childMaxScore) * 100 
       : 0;
  
  const handleClickOpenedLeadModal = () => {
      setSelectedLead(item);
      setSelectedLeadId(item._id);
      setopenDialouge(true);
  };
  
  return (
    <div
      ref={drag}
      style={{
        padding: '16px',
        marginBottom: '8px',
        backgroundColor: '#fff',
        borderRadius: '4px',
        border: '1px solid #ddd',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        cursor: 'move',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        fontWeight: isInProcess ? 'bold' : 'normal',
      }}
    >
      <div className='dragcards'>

        <div className="d-flex align-items-center justify-content-between">

        <h4 className='nameofClinet' style={{ margin: '0 0 4px 0' }}>{item.formsortResponse.answers.name}</h4>
        <Button className="dotsbuttons"
            id="basic-button"
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
          >
            <MoreVertIcon/>

          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'basic-button',
            }}
          >
            <MenuItem onClick={handleClickOpenedLeadModal}>View</MenuItem>
            {/* <MenuItem onClick={handleClose}>Edit</MenuItem>
            <MenuItem onClick={handleClose}>Delete</MenuItem> */}
          </Menu>

        </div>
        <div onClick={handleClickOpenedLeadModal}>
          <div className='emailClinet'>{ item.formsortResponse.answers.email_address }</div>
          <div className="submissiondate">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="19" viewBox="0 0 17 19" fill="none">
              <path d="M14.875 6.95997H2.125M5.66667 4.70997V3.20997M11.3333 4.70996V3.20996M3.54167 3.95997H3.47083C2.72755 3.95997 2.125 4.59796 2.125 5.38497V14.46C2.125 15.2884 2.75926 15.96 3.54167 15.96H13.4583C14.2408 15.96 14.875 15.2884 14.875 14.46V5.38497C14.875 4.59796 14.2724 3.95997 13.5292 3.95997H13.4583M7.79167 3.95997H9.20833" stroke="#6E6E71" strokeLinecap="round" />
            </svg>
            <span className='ms-1 datecontnet'>{ dayjs(item.formsortResponse.created_at).format('MM/DD/YY HH:mm:ss') }</span>
          </div>
          <div className="d-flex">
              <div className="location d-flex">
                  <div className="iconsLocation d-flex">
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                          <mask id="mask0_123_4095" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                              <rect width="18" height="18" fill="#6E6E71" />
                          </mask>
                          <g mask="url(#mask0_123_4095)">
                              <path d="M9 18C7.38717 18 6.06733 17.7942 5.0405 17.3825C4.0135 16.971 3.5 16.4397 3.5 15.7885C3.5 15.4782 3.6465 15.181 3.9395 14.897C4.23233 14.6132 4.63392 14.3718 5.14425 14.173L5.93075 14.8405C5.65258 14.9455 5.36508 15.0846 5.06825 15.2578C4.77142 15.4308 4.58583 15.6013 4.5115 15.7693C4.62567 16.1001 5.10967 16.3879 5.9635 16.6327C6.81733 16.8776 7.82633 17 8.9905 17C10.1545 17 11.1676 16.8776 12.0297 16.6327C12.8919 16.3879 13.3801 16.1001 13.4943 15.7693C13.4418 15.5974 13.2501 15.425 12.9193 15.252C12.5884 15.0788 12.2756 14.9397 11.9808 14.8345L12.7615 14.1615C13.318 14.3642 13.7468 14.6074 14.048 14.8913C14.3493 15.1753 14.5 15.4714 14.5 15.7797C14.5 16.4336 13.9865 16.9671 12.9595 17.3803C11.9327 17.7934 10.6128 18 9 18ZM9.025 13.75C10.6878 12.4563 11.9327 11.1907 12.7595 9.953C13.5865 8.71517 14 7.49875 14 6.30375C14 4.55308 13.4615 3.23142 12.3845 2.33875C11.3077 1.44625 10.1827 1 9.0095 1C7.8365 1 6.70833 1.44675 5.625 2.34025C4.54167 3.23375 4 4.55683 4 6.3095C4 7.46083 4.4115 8.65033 5.2345 9.878C6.05767 11.1055 7.32117 12.3962 9.025 13.75ZM9 15C6.98567 13.4703 5.48208 11.9847 4.48925 10.5433C3.49642 9.10175 3 7.68967 3 6.307C3 5.26267 3.18042 4.34908 3.54125 3.56625C3.90225 2.78358 4.37117 2.1275 4.948 1.598C5.525 1.0685 6.17025 0.669834 6.88375 0.402C7.59725 0.134 8.30367 0 9.003 0C9.70233 0 10.4078 0.134 11.1193 0.402C11.8308 0.669834 12.475 1.0685 13.052 1.598C13.6288 2.1275 14.0977 2.78417 14.4587 3.568C14.8196 4.35167 15 5.26358 15 6.30375C15 7.68692 14.5036 9.0995 13.5107 10.5415C12.5179 11.9835 11.0143 13.4697 9 15ZM9.0095 7.7885C9.45067 7.7885 9.82858 7.63433 10.1432 7.326C10.4581 7.01767 10.6155 6.63658 10.6155 6.18275C10.6155 5.72892 10.4573 5.34458 10.1408 5.02975C9.82442 4.71508 9.44417 4.55775 9 4.55775C8.56533 4.55775 8.18742 4.71592 7.86625 5.03225C7.54508 5.34858 7.3845 5.72883 7.3845 6.173C7.3845 6.63333 7.54508 7.01767 7.86625 7.326C8.18742 7.63433 8.5685 7.7885 9.0095 7.7885Z" fill="#6E6E71" />
                          </g>
                      </svg>
              </div> 
              <span> { item.formsortResponse.answers.country_of_residence } </span></div>
          </div>
          <div className="text-end d-flex justify-content-end mt-2 w-100">
            <div className="bvdqscore">
              BVDQ Score: { item.bvdqScores }
            </div>
          </div>
        </div>
              
        {/* <p style={{ margin: '0', color: '#666' }}>{description}</p> */}
      </div>
       <AddNotesModal
          open={openM}
          handleClose={handleCloseMdle}
          leadId={selectedLeadId}
        />
      <Dialog
          onClose={handleClosedLeadModal}
          aria-labelledby="customized-dialog-title"
          open={openDialouge}
          className="weighty"
        >
          <div className="d-flex align-items-center justify-content-between">
            <DialogTitle id="customized-dialog-title">
              Patient Profile
            </DialogTitle>
            <div className="d-flex align-items-center">
              <IconButton aria-label="close" onClick={handleClosedLeadModal}>
                <CloseIcon />
              </IconButton>
            </div>
          </div>

          <DialogContent dividers className="modelcontentSection">
            <div className="row" ref={dialogRef}>
              <div className="col-lg-4 col-sm-12 border-side">
                <ContactInfoForm 
                  selectedLead={selectedLead}
                  getclassName={getclassName}
                  handleStatusUpdate={handleStatusUpdate}
                  handleCopy={handleCopy}
                />

                <Notes
                  leadId={selectedLead?._id}
                  setOpen={setOpenM}
                  updatedNotes={updatedNotes}
                />
              </div>
              <div className="col-lg-8 col-sm-12 ">
                <div className="row mb-3">
                  <div className="col-lg-3 col-sm-12">
                    <div className="blockdig new-blockdig-controller">
                      <h6>
                        {getAgeCategory(selectedLead?.formsortResponse?.answers?.age)}
                      </h6>
                      <p>{formatDate(selectedLead?.created_at)}</p>
                    </div>
                  </div>
                  <div className="col-lg-5 col-sm-12">
                    <div className="blockdig new-blockdig-controller">
                      <h6>
                        BVDQ™ Score of <span className="blued">{score}</span>
                      </h6>

                      {answers?.above13age_bvdq_scores ? (
                        <div className="custom-slider-container">
                          <div className="custom-slider-bar" ref={sliderBarRef}>
                            <div
                              className="custom-slider-segment custom-unlikely"
                              style={{
                                left: 0,
                                width: `calc((14 / 75) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-unlikely">
                                Unlikely
                                <br />
                                <span>0-14</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-segment custom-mild"
                              style={{
                                left: `calc((14 / 75) * 100%)`,
                                width: `calc((10 / 75) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-mild">
                                Mild
                                <br />
                                <span>15-24</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-segment custom-moderate"
                              style={{
                                left: `calc((24 / 75) * 100%)`,
                                width: `calc((15 / 75) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-moderate">
                                Moderate
                                <br />
                                <span>25-39</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-segment custom-severe"
                              style={{
                                left: `calc((39 / 75) * 100%)`,
                                width: `calc((36 / 75) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-severe">
                                Severe
                                <br />
                                <span>40-75</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-pointer"
                              ref={pointerRef}
                              style={{
                                left: `calc(${adultPointerPosition}% - 10px)`,
                              }}
                            ></div>
                          </div>
                        </div>
                      ) : answers?.["4to8age_bvdq_scores"] ? (
                        <div className="custom-slider-container">
                          <div className="custom-slider-bar" ref={sliderBarRef}>
                            <div
                              className="custom-slider-segment custom-unlikely"
                              style={{
                                left: 0,
                                width: `calc((3 / 13) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-unlikely">
                                Unlikely
                                <br />
                                <span>0-3</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-segment custom-mild"
                              style={{
                                left: `calc((3 / 13) * 100%)`,
                                width: `calc((4 / 13) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-mild">
                                Mild
                                <br />
                                <span>4-7</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-segment custom-moderate"
                              style={{
                                left: `calc((7 / 13) * 100%)`,
                                width: `calc((3 / 13) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-moderate">
                                Moderate
                                <br />
                                <span>8-10</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-segment custom-severe"
                              style={{
                                left: `calc((10 / 13) * 100%)`,
                                width: `calc((3 / 13) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-severe">
                                Severe
                                <br />
                                <span>11-13</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-pointer"
                              ref={pointerRef}
                              style={{
                                left: `calc(${childPointerPosition}% - 10px)`,
                              }}
                            >
                            </div>
                          </div>
                        </div>
                      ) : answers?.["9to13age_bvdq_scores"] ? (
                        <div className="custom-slider-container">
                          <div className="custom-slider-bar" ref={sliderBarRef}>
                            <div
                              className="custom-slider-segment custom-unlikely"
                              style={{
                                left: 0,
                                width: `calc((9 / 48) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-unlikely">
                                Unlikely
                                <br />
                                <span>0-9</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-segment custom-mild"
                              style={{
                                left: `calc((9 / 48) * 100%)`,
                                width: `calc((6 / 48) * 100%)`,
                              }}
                            >
                              <div className="custom-slider- mt-5 custom-label-mild">
                                Mild
                                <br />
                                <span>10-15</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-segment custom-moderate"
                              style={{
                                left: `calc((15 / 48) * 100%)`,
                                width: `calc((10 / 48) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-moderate">
                                Moderate
                                <br />
                                <span>16-25</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-segment custom-severe"
                              style={{
                                left: `calc((25 / 48) * 100%)`,
                                width: `calc((23 / 48) * 100%)`,
                              }}
                            >
                              <div className="custom-slider-label mt-5 custom-label-severe">
                                Severe
                                <br />
                                <span>26-48</span>
                              </div>
                            </div>
                            <div
                              className="custom-slider-pointer"
                              ref={pointerRef}
                              style={{
                                left: `calc(${preteenPointerPosition}% - 10px)`,
                              }}
                            >
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div>No Scale available</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-12">
                    <div className="blockdig new-blockdig-controller">
                      <h6>
                        SSI Score of{" "}
                        <span className="reds">
                          {
                            selectedLead?.formsortResponse?.answers?.ssi_scores
                          }
                        </span>
                      </h6>
                      <p>Top 3 Symptoms by Severity</p>
                      <div className="symptonlist">
                        {topSymptoms.map((symptom, index) => (
                          <div key={index} className="chip">
                            {symptom.name}: {symptom.value}
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-8 col-sm-12">
                    <div className="scoreborad greybackbox">
                      <h5>
                        Symptom Frequency (BVDQ Score:{" "}
                        {answers?.above13age_bvdq_scores ??
                          answers?.["4to8age_bvdq_scores"] ??
                          answers?.["9to13age_bvdq_scores"] ??
                          "--"}
                        )
                      </h5>

                      {answers?.above13age_bvdq_scores ? (
                        <div className="questionblockw">
                          {above13AgeQuestionsBVDQ.map((item, index) => (
                            <div
                              key={index}
                              className={`d-flex align-items-center justify-content-between ${
                                answers?.[item.key] === "Always"
                                  ? "hightedquestion"
                                  : ""
                              }`}
                            >
                              {item.question} <span className="question"></span>
                              <span className="reason">
                                {answers?.[item.key]}
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : answers?.["4to8age_bvdq_scores"] ? (
                        <div className="questionblockw">
                          {age4to8QuestionsBVDQ.map((item, index) => (
                            <div
                              key={index}
                              className={`d-flex align-items-center justify-content-between ${
                                answers?.[item.key] === "Yes"
                                  ? "hightedquestion"
                                  : ""
                              }`}
                            >
                              {item.question} <span className="question"></span>
                              <span className="reason">
                                {answers?.[item.key]}
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : answers?.["9to13age_bvdq_scores"] ? (
                        <div className="questionblockw">
                          {age9to13QuestionsBVDQ.map((item, index) => (
                            <div
                              key={index}
                              className={`d-flex align-items-center justify-content-between ${
                                answers?.[item.key] === "Always"
                                  ? "hightedquestion"
                                  : ""
                              }`}
                            >
                              {item.question} <span className="question"></span>
                              <span className="reason">
                                {answers?.[item.key]}
                              </span>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div>No questions available</div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-4 col-sm-12">
                    <div className="greybackbox">
                      <h5>
                        Level of Discomfort (SSI:{" "}
                        {
                          selectedLead?.formsortResponse?.answers
                            ?.ssi_scores
                        }
                        )
                      </h5>
                      {Object.keys(symptomKeyMap).map((displayName) => {
                        const answerKey = symptomKeyMap[displayName];
                        if (answers && answers[answerKey] !== undefined) {
                          const isTopSymptom =
                            topSymptomNames.includes(displayName);
                          return (
                            <div
                              key={answerKey}
                              className={`smallitems d-flex align-items-center justify-content-between ${
                                isTopSymptom ? "highlighted" : ""
                              }`}
                            >
                              <span>{displayName}:</span>
                              <span>{answers[answerKey]}</span>
                            </div>
                          );
                        }

                        return null;
                      })}
                    </div>
                    <div className="greybackbox">
                      <h5>Health History</h5>
                      {answers?.above13age_bvdq_scores ? (
                        <>
                          {above13AgeQuestionsHistory.map((item, index) =>
                            answers?.[item.key] == "Yes" ? (
                              <strong key={index}>
                                <div className="d-flex align-items-center font-small justify-content-between">
                                  <span className='nowrap-custom'>{item.question}</span>
                                  <span>{answers?.[item.key]}</span>
                                </div>
                              </strong>
                            ) : (
                              <div
                                key={index}
                                className="d-flex align-items-center font-small justify-content-between"
                              >
                                <span className='nowrap-custom'>{item.question}</span>
                                <span>{answers?.[item.key]}</span>
                              </div>
                            )
                          )}
                        </>
                      ) : answers?.["4to8age_bvdq_scores"] ? (
                        <>
                          {age4to8QuestionsHistory.map((item, index) =>
                            answers?.[item.key] == "Yes" ? (
                              <strong key={index}>
                                <div className="d-flex align-items-center font-small justify-content-between">
                                  <span className='nowrap-custom'>{item.question}</span>
                                  <span>{answers?.[item.key]}</span>
                                </div>
                              </strong>
                            ) : (
                              <div
                                key={index}
                                className="d-flex align-items-center font-small justify-content-between"
                              >
                                <span className='nowrap-custom'>{item.question}</span>
                                <span>{answers?.[item.key]}</span>
                              </div>
                            )
                          )}
                        </>
                      ) : answers?.["9to13age_bvdq_scores"] ? (
                        <>
                          {age9to13QuestionsHistory.map((item, index) =>
                            answers?.[item.key] == "Yes" ? (
                              <strong key={index}>
                                <div className="d-flex align-items-center font-small justify-content-between">
                                  <span className='nowrap-custom'>{item.question}</span>
                                  <span>{answers?.[item.key]}</span>
                                </div>
                              </strong>
                            ) : (
                              <div
                                key={index}
                                className="d-flex align-items-center font-small justify-content-between"
                              >
                                <span className='nowrap-custom'>{item.question}</span>
                                <span>{answers?.[item.key]}</span>
                              </div>
                            )
                          )}
                        </>
                      ) : (
                        <div>No health history questions available</div>
                      )}
                    </div>
                    <div className="greybackbox">
                      <h5>Additional Comments</h5>
                      <p className="eplippsewrap">
                        {answers?.comments
                          ? answers.comments
                          : "No Comments Available"}
                      </p>
                    </div>
                  </div>
                </div>
                
              </div>
            </div>
          </DialogContent>
        </Dialog>
    </div>
  );
};

// Drop zone component
const DropZone = ({ id, title, color, items, moveItem }) => {
  const [, drop] = useDrop({
    accept: ItemType,
    drop: (item) => moveItem(item.id, id),
  });

  return (
    <div
      ref={drop}
      style={{
        backgroundColor: color,
        padding: '12px',
        minWidth: '250px',
        minHeight: '500px',
        margin: '8px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <h2 style={{ margin: '0 0 8px 0' }}>{title}</h2>
      {items.map(item => (
        <DraggableItem
          key={item._id}
          id={item._id}
          item = {item}
          columnId={id}
          moveItem={moveItem}
        />
      ))}
    </div>
  );
};

// Main component
export const Dragdrop = ({ bvdqScore, providerId, birthday, search }) => {

  const { encryptData, decryptData } = useEncryption();
  const params = useParams();
  const toastOptions = useToast();
  const headers = useHeaders();
  const [loading, setLoading] = React.useState(false);  
  const [rows, setRows] = useState([]);  
  const decryptedId = decryptData(decodeURIComponent(params.id));
  const [columns, setColumns] = useState({
    'New Lead': {
      id: 'New Lead',
      title: 'New Lead',
      color: '#EEF2FC',
      // items: [
      //   { id: 'item-1', title: 'Item 1', description: 'Description for Item 1', icon: 'https://via.placeholder.com/24' },
      //   { id: 'item-2', title: 'Item 2', description: 'Description for Item 2', icon: 'https://via.placeholder.com/24' }
      // ],
      items : []
    },
    'Scheduled For Contact': {
      id: 'Scheduled For Contact',
      title: 'Scheduled for Contact',
      color: '#E5F4FF',
      items : []
    },
    'Contact Attempted': {
      id: 'Contact Attempted',
      title: 'Contact Attempted',
      color: '#C9E8E8',
      items : []
    },
    'Ready To Schedule': {
      id: 'Ready To Schedule',
      title: 'Ready To Schedule',
      color: '#F9E1BF',
      items : []
    },
    'In Process': {
      id: 'In Process',
      title: 'In Process',
      color: '#FFF3DD',
      items : []
    },
    'Scheduled': {
      id: 'Scheduled',
      title: 'Scheduled',
      color: '#D7C9E8',
      items : []
    },
    'UnScheduled': {
      id: 'UnScheduled',
      title: 'Unscheduled',
      color: '#D6D8DB',
      items : []
    },
    'Archived': {
      id: 'Archived',
      title: 'Archived',
      color: '#D6D8DB',
      items : []
    },
  });


  useEffect(() => {
    fetchData();
  }, [bvdqScore, providerId, birthday, search ]);

  const fetchData = async () => {
      try {
          setLoading(true);
          const response = await getAllPipeLineLeadsApi(bvdqScore, providerId, birthday, search )
          const decryptedData = decryptData(response?.data?.data);
          decryptedData.leads.map((data)=> data.formsortResponse = decryptData(data.formsortResponse));
          setRows(decryptedData?.leads);
          
           // Update columns with the new rows
          setColumns((prevColumns) => ({
            ...prevColumns,
            'New Lead': {
              ...prevColumns['New Lead'],
              items: (decryptedData.leads).length > 0 ? (decryptedData.leads).filter((row)=> row.status === 'New Lead') : []
            },
            'Scheduled For Contact' : {
              ...prevColumns['Scheduled For Contact'],
              items: (decryptedData.leads).length > 0 ? (decryptedData.leads).filter((row)=> row.status === 'Scheduled For Contact') : []
            },
            'Contact Attempted' : {
              ...prevColumns['Contact Attempted'],
              items: (decryptedData.leads).length > 0 ? (decryptedData.leads).filter((row)=> row.status === 'Contact Attempted') : []
            },
            'Ready To Schedule' : {
              ...prevColumns['Ready To Schedule'],
              items: (decryptedData.leads).length > 0 ? (decryptedData.leads).filter((row)=> row.status === 'Ready To Schedule') : []
            },
            'In Process' : {
              ...prevColumns['In Process'],
              items: (decryptedData.leads).length > 0 ? (decryptedData.leads).filter((row)=> row.status === 'In Process') : []
            },
            'Scheduled' : {
              ...prevColumns['Scheduled'],
              items: (decryptedData.leads).length > 0 ? (decryptedData.leads).filter((row)=> row.status === 'Scheduled') : []
            },
            'UnScheduled' : {
              ...prevColumns['UnScheduled'],
              items: (decryptedData.leads).length > 0 ? (decryptedData.leads).filter((row)=> row.status === 'UnScheduled') : []
            },
            'Archived' : {
              ...prevColumns['Archived'],
              items: (decryptedData.leads).length > 0 ? (decryptedData.leads).filter((row)=> row.status === 'Archived') : []
            }
          }));

          setLoading(false);
      } catch (error) {
          setLoading(false);
          console.error('Error fetching data:', error);
      }
  };

  const moveItem = (itemId, targetColumnId) => {
    setColumns((prevColumns) => {
      const updatedColumns = { ...prevColumns };

      // Find the source column and remove the item
      const sourceColumnId = Object.keys(prevColumns).find((columnId) =>
        prevColumns[columnId].items.some((item) => item._id === itemId)
      );

      const item = updatedColumns[sourceColumnId].items.find((item) => item._id === itemId);
      updatedColumns[sourceColumnId].items = updatedColumns[sourceColumnId].items.filter((item) => item._id !== itemId);

      // Add the item to the target column
      updatedColumns[targetColumnId].items.push(item);

      handleStatusUpdate(item._id, targetColumnId)

      return updatedColumns;
    });
  };

  const handleStatusUpdate = async (leadId, newStatus) => {
    try {
        const payload = {
            status: newStatus
        };
        const data = encryptData(payload);
        const response = await updateLeadStatusApi(leadId, data, headers);
        let obj = {
          event : 'SuperAdmin has updated the lead status.'
        }
        await createAuditLogs({ data: encryptData(obj)}, headers);
        toast.success(response.data.message, toastOptions);
    } catch (error) {
        toast.error(error?.response?.data?.message, toastOptions);
    }
  };
  
  return (
    <DndProvider backend={HTML5Backend}>
      <div style={{ display: 'flex', overflowX: 'auto', padding: '0px' }}>
        {Object.values(columns).map((column) => (
          <DropZone
            key={column.id}
            id={column.id}
            title={column.title}
            color={column.color}
            items={column.items}
            moveItem={moveItem}
          />
        ))}
      </div>
    </DndProvider>
  );
};
